module.exports = __webpack_public_path__ + "static/img/day4.b2a7ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/day4.jpg
// module id = DjId
// module chunks = 0